
export default function Container({children}) {


  return (
    <div className="container contentor">
        {children}
     
    </div>
   
  )
}
